module.exports = __webpack_public_path__ + "static/media/country_tk.cb0b78e1.webp";